const PAYMENT_TYPE_MAP = {
    0: "Advance",
    1: "To Pay"
};
const PAYMENT_STATUS = {
    LOADING: "LOADING",
    PAID: "PAID"
};
const EXPECTED_AMOUNT_TYPE = {
    0: "Fixed Price",
    1: "Per Tonne"
};
var ExpectedAmountType;
(function (ExpectedAmountType) {
    ExpectedAmountType[ExpectedAmountType["FIXED_PRICE"] = 0] = "FIXED_PRICE";
    ExpectedAmountType[ExpectedAmountType["PER_TONNE"] = 1] = "PER_TONNE";
})(ExpectedAmountType || (ExpectedAmountType = {}));
var ExpectedAmountTypeNameMapping;
(function (ExpectedAmountTypeNameMapping) {
    ExpectedAmountTypeNameMapping["FIXED_PRICE"] = "Fixed";
    ExpectedAmountTypeNameMapping["PER_TONNE"] = "Per Tonne";
})(ExpectedAmountTypeNameMapping || (ExpectedAmountTypeNameMapping = {}));
var PAYMENT_TYPE;
(function (PAYMENT_TYPE) {
    PAYMENT_TYPE[PAYMENT_TYPE["Advance"] = 0] = "Advance";
    PAYMENT_TYPE[PAYMENT_TYPE["ToPay"] = 1] = "ToPay";
})(PAYMENT_TYPE || (PAYMENT_TYPE = {}));

export { EXPECTED_AMOUNT_TYPE, ExpectedAmountType, ExpectedAmountTypeNameMapping, PAYMENT_STATUS, PAYMENT_TYPE, PAYMENT_TYPE_MAP };
//# sourceMappingURL=payment.js.map
